import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './HistoricalReturn.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../utils/useLocalStorage";
import { format, parseISO } from 'date-fns';
import MarketEquity from "../MarketEquity";
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function HistoricalReturn(props) {
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    let optionInfoMarket = "Historical Returns";
    let optionTypeComp = "Daily Market Tracker";
    const [data, setData] = useState([]);
    const [valuebtn, setValueBtn] = useState("Gain");
    // const [valueLi, setValueLi] = useState("Day");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    const [valueLy, setValueLy] = useState("M1");
    const [groupIndex, setGroupIndex] = useState("BSE_SENSEX");
    const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);

    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        if (groupValue === "BSE") {
            const getUrl = BaseURL + "HistoricalReturn";
            fetch(`${getUrl}/${groupValue}/${groupIndex}/${valueLy}/${valuebtn}/-/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    // console.log(getData, "getData")
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "HistoricalReturn";
            fetch(`${getUrl}/${groupValue}/${groupIndexNSE}/${valueLy}/${valuebtn}/-/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    //console.log(getData, "getData")
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue, valuebtn, groupIndex, valueLy, groupIndexNSE]);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
    CallTrackApi("Historical Returns",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Historical Return</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='hit-loser-sc'>
                            <div className='hit-header'>
                                <h2><span>Historical Return</span></h2>
                            </div>
                            <MarketEquity optionInfoMarket={optionInfoMarket} optionTypeComp={optionTypeComp} />
                            <div className="hit-table-main">
                                <div className='hitselect'>
                                    <div className='hit-loser-toggle'>
                                        <button id="btnGain" value="Gain" className={(valuebtn === "Gain") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Gainers</button>
                                        <button id="btnLoose" value="Lose" className={(valuebtn === "Lose") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Losers</button>
                                    </div>

                                    <div className='hit-inner-select'>
                                        
                                        {/* aria-label="Last Month" */}
                                        <select aria-label="Last Month" onChange={(event) => { setValueLy(event.target.value); }}>
                                            <option value="M1" selected>Last 1 Month</option>
                                            <option value="M3" >Last 3 Month</option>
                                            <option value="M6" >Last 6 Month</option>
                                            <option value="Y1" >Last 1 Year</option>
                                            <option value="Y3" >Last 3 Years</option>
                                        </select>
                                    </div>




                                    <div className='hit-inner-select_I'>
                                       
                                        {/* aria-label="nse bse" */}
                                        <select aria-label="nse bse" onChange={(event) => { setGroupValue(event.target.value); setGroupIndex("BSE_SENSEX"); setGroupIndexNSE("NIFTY") }}>
                                            <option value="BSE" selected>BSE</option>
                                            <option value="NSE">NSE</option>
                                        </select>

                                    </div>
                                    <div className='hit-inner-selectIndex'>
                                        {(groupValue === "BSE") ?
                                            <select aria-label="bse sensex" onChange={(event) => { setGroupIndex(event.target.value) }}>
                                                {dataGroup && dataGroup.map(({ Group }) => (
                                                    <option value={Group} selected={Group === "BSE_SENSEX"}>{Group}</option>
                                                )
                                                )}
                                            </select> : <select onChange={(event) => { setGroupIndexNSE(event.target.value) }}>
                                                {dataGroup && dataGroup.map(({ Group }) => (
                                                    <option value={Group} selected={Group === "NIFTY"}>{Group}</option>
                                                )
                                                )}
                                            </select>}
                                    </div>
                                </div>

                                {/* <hr className="hrHistorical"></hr> */}
                                <div className='hit-table table-responsive'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-left bdrright' rowspan="2">Company</th>
                                                <th className='text-center bdrright bdrbottom' colspan="2">Close Price ( {(valueLy == "M1") ? "Last 1 Month" : ''} {(valueLy == "M3") ? "Last 3 Month" : ''} {(valueLy == "M6") ? "Last 6 Month" : ''} {(valueLy == "Y1") ? "Last 1 Year" : ''} {(valueLy == 'Y3') ? "Last 3 Year" : ''})</th>
                                                <th className='text-right bdrright'>Close Price on</th>
                                                <th className='text-right bdrright' rowspan="2">Change</th>
                                                <th className='text-right' rowspan="2">%Returns</th>
                                            </tr>
                                            <tr className="head_bg">
                                                <th className="text-right bdrright"><span>(&#8377;)</span></th>
                                                <th className="text-right bdrright">Date</th>
                                                <th className='text-right bdrright'>( {(data[0] != null) ? format(parseISO(data[0].CDate), 'dd-MMM-yyyy') : ''} )</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentTableData && currentTableData.map(
                                                ({ CompName, ClosePrice, CloseDate, Cprice, Change, Ret, CO_CODE }) => (
                                                    <tr>
                                                        <td className="text-left">{CompName} </td>
                                                        <td className="text-right"> {(ClosePrice != null) ? ClosePrice.toFixed(2) : 0}</td>
                                                        <td className="text-right"> {(CloseDate != null) ? CloseDate.split('T')[0] : 0}</td>
                                                        <td className="text-right"> {(Cprice != null) ? Cprice.toFixed(2) : 0}</td>
                                                        {/* <td className="text-right"> {(Change != null) ? Change.toFixed(2) : 0}</td> */}
                                                        <td className={(Change.toFixed(2) > 0) ? "textGreen text-right" : "textRed text-right"}> {(Change != null) ? Change.toFixed(2) : 0}</td>
                                                        <td className={(Ret.toFixed(2) > 0) ? "textGreen text-right" : "textRed text-right"}> {(Ret != null) ? Ret.toFixed(2) : 0}</td>

                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }


                                </div>
                                {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default HistoricalReturn;